export default "__VITE_ASSET__c869f93d__"